<template>
  <div class="menutree">
    <label v-for="menu in data" :key="menu.id">
      <el-menu-item :index="menu.id + ''" v-if="'dashboard' === menu.path">
        <div class="menu-info">
          <div :class="menu.icon" />
          <div class="menu-title">{{ menu.name }}</div>
        </div>
      </el-menu-item>
      <el-submenu
        :index="menu.id + ''"
        v-else-if="menu.children && menu.children.length > 0"
      >
        <template slot="title">
          <div class="menu-info">
            <div :class="menu.icon" />
            <div class="menu-title">{{ menu.name }}</div>
          </div>
        </template>
        <label>
          <menutree :data="menu.children"></menutree>
        </label>
      </el-submenu>
      <el-menu-item v-else :index="menu.pid + '-' + menu.seq">
        <!-- <span slot="title">{{ menu.name }}</span> -->
        <template slot="title">
          <div class="menu-info">
            <div :class="menu.icon" />
            <div class="menu-title">{{ menu.name }}</div>
          </div>
        </template>
      </el-menu-item>
    </label>
  </div>
</template>

<script type="text/ecmascript-6">
import menutree from "@/components/tools/menutree";
export default {
  name: "menutree",
  data() {
    return {};
  },
  components: {
    menutree: menutree,
  },
  props: ["data"],
};
</script>


// WEBPACK FOOTER //
// src/components/tools/menutree.vue